import React from "react";
import SmartScrollRow from "./SmartScrollRow.js";
import "./SubNavbar.scss";

const PILL_WIDTHS = [72, 96, 84, 108, 76, 92, 88, 80];

/** Placeholder subcategory row — same shell as SubNavbar while products load. */
const SubNavbarSkeleton = () => (
  <nav
    className="sub-navbar sub-navbar--level-1 sub-navbar--skeleton"
    aria-hidden="true"
  >
    <SmartScrollRow rtl trackClassName="sub-navbar__scroll-track">
      {PILL_WIDTHS.map((width, index) => (
        <span
          key={index}
          className="skeleton sub-navbar-skeleton__pill"
          style={{ width: `${width}px` }}
        />
      ))}
    </SmartScrollRow>
  </nav>
);

export default SubNavbarSkeleton;
